var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M511.808,123.616c-1.472-19.776-18.112-35.328-38.208-35.328H38.272 c-20.096,0-36.608,15.488-38.208,35.328H0v264.832h0.128c1.472,19.776,18.048,35.264,38.144,35.264H473.6 c20.224,0,36.672-15.616,38.208-35.328H512V123.616H511.808z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 123.62,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 264.83
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 256,
    cy: 256.03,
    r: 114.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M233.984,316.32l-17.728,3.008c-2.176,0.384-4.288-1.28-4.288-3.584v-6.72h22.016L233.984,316.32 L233.984,316.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M277.888,316.32l17.728,3.008c2.176,0.384,4.288-1.28,4.288-3.584v-6.72h-22.016V316.32 L277.888,316.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M252.288,197.216h-1.472c-1.792,0-3.52-1.024-4.288-2.688l-2.688-5.376l2.496-1.216l2.688,5.376 c0.384,0.704,1.088,1.088,1.92,1.088h1.472v2.816L252.288,197.216L252.288,197.216z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.945,
    y: 195.396,
    transform: "matrix(-0.4472 -0.8944 0.8944 -0.4472 149.6537 485.9717)",
    style: {
      fill: "#965032"
    },
    width: 10.112,
    height: 2.688
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M260.992,239.52l-7.488-7.488c-1.6-1.6-2.624-3.904-2.624-6.208v-2.496 c0-0.896-0.192-1.92-0.576-2.688l-1.92-3.712c-0.384-0.832-1.216-1.28-1.984-1.28h-6.528c-1.92,0-3.584-1.088-4.48-2.816 l-2.624-5.312l2.496-1.216l2.624,5.312c0.384,0.832,1.216,1.28,1.984,1.28h6.528c1.92,0,3.584,1.088,4.48,2.816l1.92,3.712 c0.576,1.216,0.896,2.624,0.896,3.904v2.496c0,1.6,0.576,3.072,1.792,4.224l2.816,2.816v-12.8c0-3.52-1.216-6.912-3.392-9.6 c-2.624-3.2-4.032-7.232-4.032-11.328v-10.624h2.688v10.624c0,3.52,1.216,6.912,3.392,9.6c2.624,3.2,4.032,7.232,4.032,11.328 L260.992,239.52L260.992,239.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M254.4,232.416h-4.096c-2.496,0-4.8-1.6-5.696-3.904l-1.024-2.816l2.624-1.024l1.024,2.816 c0.512,1.28,1.728,2.112,3.072,2.112h4.096V232.416L254.4,232.416z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.922,
    y: 183.324,
    transform: "matrix(-0.915 -0.4035 0.4035 -0.915 414.7991 492.3181)",
    style: {
      fill: "#965032"
    },
    width: 2.688,
    height: 38.271
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#965032"
    },
    points: "272,215.648 258.688,215.648 258.688,212.832 269.184,212.832 269.184,199.52 272,199.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M246.784,228.832h-11.008c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504 h11.008c3.008,0,5.504,2.496,5.504,5.504l0,0C252.288,226.464,249.792,228.832,246.784,228.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M272.384,228.832h-11.008c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504 h11.008c3.008,0,5.504,2.496,5.504,5.504l0,0C277.888,226.464,275.52,228.832,272.384,228.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M283.392,217.824H268.8c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504 h14.592c3.008,0,5.504,2.496,5.504,5.504l0,0C288.896,215.456,286.4,217.824,283.392,217.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M287.104,203.232h-25.6c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504h25.6 c3.008,0,5.504,2.496,5.504,5.504l0,0C292.608,200.736,290.112,203.232,287.104,203.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M272.384,188.64h-7.296c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504 h7.296c3.008,0,5.504,2.496,5.504,5.504l0,0C277.888,186.144,275.52,188.64,272.384,188.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M224.832,195.936h-3.712c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504 h3.712c3.008,0,5.504,2.496,5.504,5.504l0,0C230.272,193.44,227.904,195.936,224.832,195.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M250.496,192.224h-11.008c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504 h11.008c3.008,0,5.504,2.496,5.504,5.504l0,0C255.872,189.856,253.504,192.224,250.496,192.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M246.784,210.528h-22.016c-3.008,0-5.504-2.496-5.504-5.504l0,0c0-3.008,2.496-5.504,5.504-5.504 h22.016c3.008,0,5.504,2.496,5.504,5.504l0,0C252.288,208.16,249.792,210.528,246.784,210.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M310.912,287.136H201.024c-4.032,0-7.296,3.328-7.296,7.296s3.328,7.296,7.296,7.296h29.312 c0,4.032,3.328,7.296,7.296,7.296h36.608c4.032,0,7.296-3.328,7.296-7.296h29.312c4.032,0,7.296-3.328,7.296-7.296 C318.208,290.336,314.88,287.136,310.912,287.136z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE7855"
    },
    d: "M328.896,222.112c-0.32-0.512-1.728,0.128-2.624-0.192c-11.072-4.096-25.92-11.584-35.584-16.704 l-1.92-3.072l-18.368-8.896c-1.216-0.576-2.624-0.128-3.2,1.024l-0.896,1.6c-0.704,1.216-0.192,2.816,1.024,3.392l17.472,9.088 l4.992-0.384l19.2,9.92c0,0,13.12,6.72,13.824,7.232s1.088,3.2,2.432,3.008C326.08,227.808,330.112,224.544,328.896,222.112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M207.616,292.512c0,0,1.216,5.376,0.128,6.016c-1.088,0.576-7.232,0.576-7.104-0.704 c0.192-1.28,1.024-5.888,1.024-5.888L207.616,292.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M217.728,289.632c0,0-1.024,4.032,1.024,4.224s13.184,0.128,13.504-0.192 c0.32-0.32,0.704-1.088,0.704-1.088l-10.432-2.88h-4.8L217.728,289.632L217.728,289.632z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M206.272,239.264c0,0-2.688,6.528-3.712,28.928c-0.32,6.016,0.512,4.608-2.496,23.808l3.52,1.792 c1.024,0.512,2.304,0.512,3.328-0.128l3.392-2.112c0,0-1.728-21.504,3.776-33.92c0,0,2.88,5.312,2.88,9.28 s-0.192,22.976-0.192,22.976s6.4,1.088,9.28,0.832c0,0-1.792-41.408-3.712-51.072L206.272,239.264z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M206.912,236.512c0,0-1.088,0.832-0.512,2.688c0,0,8.384,3.584,16.192,0.512 c0,0,0.896-1.28-0.192-2.816L206.912,236.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M195.712,216.736c-4.8,1.792-12.032,6.208-11.52,9.728s2.88,2.688,3.712,1.792 s3.008-3.584,3.712-4.096c0.704-0.512,11.904-6.272,11.904-6.272l29.824-15.296c0,0,0.192-1.472-1.472-2.688 C231.68,199.84,213.504,210.016,195.712,216.736z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M209.728,199.456l-0.192,1.28c0,0-0.512,8.128,2.176,10.176c0,0,0.576,1.728-0.32,2.496 c-0.896,0.832-9.984,5.376-9.984,5.376s-2.304,4.928-2.304,7.616c0,0-2.176-0.896-1.984-1.92c0.192-1.088,1.472-3.904,1.088-5.312 s-1.92-1.024-1.92-1.024s-0.704,0.832,0.512,1.28l-0.384,1.728l-4.928,2.88l1.088,1.28c0,0,0.128,10.112,6.016,11.392 c0,0,3.072,0.192,6.912-6.912c0,0,1.984,3.52,1.28,6.592c0,0,6.528,3.52,15.424,0.512l0.128-6.208c0,0,1.408,9.472,6.08,8.576 c0,0,12.992-4.992,10.816-6.912c-4.992-4.416-11.072-0.704-11.072-0.704c-0.32-6.4-0.832-14.72-1.728-15.616 c-1.408-1.472-5.632-0.704-6.4-2.624c-0.832-1.92-0.576-5.312,0.32-9.216s-3.712-6.592-3.712-6.592L209.728,199.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M209.6,200.736c0,0,4.672,1.216,8.32-0.32l1.6,4.032h0.896c0,0,2.176-7.296-0.704-7.296 c0,0,0-2.432-5.12-2.304C210.176,194.912,208.576,197.856,209.6,200.736z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M304.896,292.512c0,0-1.216,5.376-0.128,6.016c1.088,0.576,7.232,0.576,7.104-0.704 c-0.192-1.28-1.024-5.888-1.024-5.888L304.896,292.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M294.784,289.632c0,0,1.024,4.032-1.024,4.224c-2.048,0.192-13.184,0.128-13.504-0.192 c-0.32-0.32-0.704-1.088-0.704-1.088l10.368-2.88h4.864L294.784,289.632L294.784,289.632z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M306.112,239.264c0,0,2.688,6.528,3.712,28.928c0.32,6.016-0.512,4.608,2.496,23.808l-3.52,1.792 c-1.024,0.512-2.304,0.512-3.328-0.128l-3.392-2.112c0,0,1.728-21.504-3.776-33.92c0,0-2.88,5.312-2.88,9.28 s0.192,22.976,0.192,22.976s-6.4,1.088-9.28,0.832c0,0,1.792-41.408,3.712-51.072L306.112,239.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE7855"
    },
    d: "M305.6,236.512c0,0,1.088,0.832,0.512,2.688c0,0-8.384,3.584-16.192,0.512 c0,0-0.896-1.28,0.192-2.816L305.6,236.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M302.784,199.456l0.192,1.28c0,0,0.512,8.128-2.176,10.176c0,0-0.576,1.728,0.32,2.496 c0.896,0.832,9.984,5.376,9.984,5.376s2.304,4.928,2.304,7.616c0,0,2.176-0.896,1.984-1.92c-0.192-1.088-1.472-3.904-1.088-5.312 c0.384-1.408,1.92-1.024,1.92-1.024s0.704,0.832-0.512,1.28l0.384,1.728l4.928,2.88l-1.088,1.28c0,0-0.128,10.112-6.016,11.392 c0,0-3.072,0.192-6.912-6.912c0,0-1.984,3.52-1.28,6.592c0,0-6.528,3.52-15.424,0.512l-0.128-6.208c0,0-1.408,9.472-6.08,8.576 c0,0-12.992-4.992-10.816-6.912c4.992-4.416,11.072-0.704,11.072-0.704c0.32-6.4,0.832-14.72,1.728-15.616 c1.408-1.472,5.632-0.704,6.4-2.624c0.832-1.92,0.576-5.312-0.32-9.216s3.712-6.592,3.712-6.592L302.784,199.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M302.912,200.736c0,0-4.672,1.216-8.32-0.32l-1.6,4.032h-0.896c0,0-2.176-7.296,0.704-7.296 c0,0,0-2.432,5.12-2.304C302.272,194.912,303.872,197.856,302.912,200.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M224.512,203.744c-0.384-0.896,0.32-1.216,0.32-1.216s4.608-2.496,5.184-2.496 c0.896,0.128,1.984,1.6,1.984,3.008c0,1.28,1.728,4.8,5.312,5.696c0,0-4.48,6.08-10.688,5.184 C226.496,213.92,226.88,209.824,224.512,203.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M230.976,232.16c-1.408,0-2.496,1.216-2.496,2.624v30.272c0,7.296,3.392,33.024,27.52,40.32 c24-7.296,27.52-33.024,27.52-40.32v-30.272c0-1.472-1.088-2.624-2.496-2.624H230.976L230.976,232.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M283.392,265.12v-30.272c0-1.472-1.088-2.624-2.496-2.624h-25.024v25.6L280,281.952 C282.688,274.848,283.392,268.32,283.392,265.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M228.48,265.12v-30.272c0-1.472,1.088-2.624,2.496-2.624H256v25.6l-24.128,24.128 C229.12,274.848,228.48,268.32,228.48,265.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C5A28"
    },
    points: "239.68,281.12 246.08,287.84 263.808,287.84 267.52,283.04 263.232,284.832 248.896,284.832  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M246.592,272.416l-1.024,9.792l-4.416-1.728C241.216,280.544,243.2,275.808,246.592,272.416z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.3,
    y: 268.64,
    style: {
      fill: "#8C5A28"
    },
    width: 0.704,
    height: 16.704
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.31,
    y: 270.05,
    style: {
      fill: "#8C5A28"
    },
    width: 0.704,
    height: 15.232
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.28,
    y: 270.05,
    style: {
      fill: "#8C5A28"
    },
    width: 0.704,
    height: 15.232
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M257.792,283.616h-4.416c-0.32,0-0.512-0.192-0.512-0.512v-2.368c0-0.32,0.192-0.512,0.512-0.512 h4.416c0.32,0,0.512,0.192,0.512,0.512v2.368C258.432,283.424,258.112,283.616,257.792,283.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M257.792,279.008h-4.416c-0.32,0-0.512-0.192-0.512-0.512V276c0-0.32,0.192-0.512,0.512-0.512h4.416 c0.32,0,0.512,0.192,0.512,0.512v2.432C258.432,278.752,258.112,279.008,257.792,279.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M257.792,274.656h-4.416c-0.32,0-0.512-0.192-0.512-0.512v-2.368c0-0.32,0.192-0.512,0.512-0.512 h4.416c0.32,0,0.512,0.192,0.512,0.512v2.368C258.432,274.464,258.112,274.656,257.792,274.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M263.488,283.616h-3.712c-0.32,0-0.512-0.192-0.512-0.512v-2.368c0-0.32,0.192-0.512,0.512-0.512 h3.712c0.32,0,0.512,0.192,0.512,0.512v2.368C264,283.424,263.808,283.616,263.488,283.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M263.488,279.328h-3.712c-0.32,0-0.512-0.192-0.512-0.512v-1.92c0-0.32,0.192-0.512,0.512-0.512 h3.712c0.32,0,0.512,0.192,0.512,0.512v1.92C264,279.136,263.808,279.328,263.488,279.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M263.488,275.104h-3.712c-0.32,0-0.512-0.192-0.512-0.512v-1.408c0-0.32,0.192-0.512,0.512-0.512 h3.712c0.32,0,0.512,0.192,0.512,0.512v1.408C264,274.848,263.808,275.104,263.488,275.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M251.392,283.616h-3.712c-0.32,0-0.512-0.192-0.512-0.512v-2.368c0-0.32,0.192-0.512,0.512-0.512 h3.712c0.32,0,0.512,0.192,0.512,0.512v2.368C252.032,283.424,251.712,283.616,251.392,283.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M251.392,279.328h-3.712c-0.32,0-0.512-0.192-0.512-0.512v-1.92c0-0.32,0.192-0.512,0.512-0.512 h3.712c0.32,0,0.512,0.192,0.512,0.512v1.92C252.032,279.136,251.712,279.328,251.392,279.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M251.392,275.104h-3.712c-0.32,0-0.512-0.192-0.512-0.512v-1.408c0-0.32,0.192-0.512,0.512-0.512 h3.712c0.32,0,0.512,0.192,0.512,0.512v1.408C252.032,274.848,251.712,275.104,251.392,275.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "261.312,270.048 261.312,272.032 258.432,271.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "249.28,270.048 249.28,272.032 246.4,271.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "255.296,268.64 255.296,270.56 252.416,269.536  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M277.696,287.136h-43.584c0.576,1.216,1.408,2.496,2.176,3.712h39.296 C276.416,289.504,277.12,288.352,277.696,287.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M275.584,290.72h-39.296l0,0c1.728,2.624,3.904,5.12,6.4,7.296h26.432 C271.68,295.84,273.792,293.344,275.584,290.72L275.584,290.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M242.688,298.016c3.52,3.072,7.808,5.696,13.184,7.296c5.376-1.6,9.728-4.224,13.184-7.296H242.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE7855"
    },
    d: "M251.2,259.936c0,0-0.32,0.128-0.576,0.128c-0.192-0.128-0.704-0.128-0.384-1.024 c0.128-0.384,0.384-1.024,0.192-1.216s-0.32-0.384-0.512-0.576c-0.384-0.384-0.832-0.896-1.28-1.472 c-1.024-1.088-2.112-2.304-3.392-3.52c-0.704-0.576-1.28-1.216-1.984-1.92c-0.704-0.576-1.408-1.28-2.176-1.92 c-0.384-0.192-1.024-0.384-1.472-0.512c-0.512-0.192-0.832-0.576-1.088-0.896c-0.704-0.576-1.408-1.28-1.984-1.92 c-1.28-1.216-2.496-2.368-3.52-3.392s-1.792-1.792-2.304-2.432c-0.512-0.576-0.512-1.472,0.128-1.984l1.6-1.6 c0.576-0.512,1.472-0.512,1.984,0c0.576,0.576,1.408,1.408,2.432,2.368c1.024,0.96,2.112,2.304,3.328,3.584 c0.576,0.704,1.216,1.408,1.792,2.112c0.32,0.384,0.704,0.704,0.832,1.216c0.192,0.512,0.32,1.088,0.512,1.472 c0.512,0.832,1.216,1.472,1.792,2.176s1.216,1.408,1.792,2.112c1.216,1.408,2.304,2.624,3.392,3.584 c0.512,0.512,1.024,0.896,1.408,1.28c0.192,0.192,0.384,0.384,0.576,0.576c0.128,0.192,0.704-0.128,1.216-0.192 c0.896-0.192,0.896,0.192,0.896,0.384c0,0.32-0.128,0.576-0.128,0.576L251.2,259.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M233.28,262.816c-0.32,0-0.576-0.128-0.832-0.32c-0.576-0.512-0.704-1.28-0.32-1.92l12.992-17.728 c0.384-0.576,1.28-0.704,1.92-0.32c0.576,0.512,0.704,1.28,0.32,1.92l-12.992,17.728 C234.112,262.624,233.728,262.816,233.28,262.816z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "243.712,241.76 250.496,246.24 253.376,242.208 247.104,237.152 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M261.824,240.032l17.408,21.504c0,0,2.432,0.128,2.112-1.792l-17.984-21.12L261.824,240.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M257.92,243.04c0,0,4.928-0.896,6.912-3.904l2.816,3.328c0,0-4.608,3.2-4.992,6.72 C262.592,249.056,258.88,248.032,257.92,243.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M276.672,240.864c-0.32,0-0.576-0.192-0.832-0.512c-0.512-0.896-0.576-1.792-0.32-2.496 c0.512-1.024,1.472-1.28,1.728-1.408c0.512-0.128,1.024,0.192,1.088,0.576c0.128,0.512-0.192,1.024-0.576,1.088 c-0.128,0-0.384,0.192-0.512,0.384s0,0.576,0.192,1.024c0.192,0.384,0.128,1.024-0.384,1.216 C276.992,240.864,276.8,240.864,276.672,240.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M262.4,254.112c0-0.32-0.192-0.576-0.512-0.832c-0.896-0.512-1.792-0.576-2.496-0.32 c-1.024,0.512-1.28,1.472-1.408,1.728c-0.128,0.512,0.192,1.024,0.576,1.088c0.512,0.128,1.024-0.192,1.088-0.576 c0-0.128,0.192-0.384,0.384-0.512c0.192-0.128,0.576,0,1.024,0.192c0.384,0.192,1.024,0.128,1.216-0.384 C262.4,254.432,262.4,254.24,262.4,254.112z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAF3F5"
    },
    points: "277.312,238.816 260.928,254.944 264.704,259.232 280.768,243.104 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M194.112,215.712c1.088-0.32,2.112,1.216,1.088,2.304s-3.904,3.008-4.672,2.816 C188.928,220.512,187.776,217.12,194.112,215.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M318.272,217.248c-1.024-0.32-1.92,1.216-1.024,2.304c0.896,1.088,3.584,3.008,4.416,2.816 C323.2,222.048,324.096,218.72,318.272,217.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M280.896,232.16c1.408,0,2.496,1.216,2.496,2.624v30.272c0,7.296-3.392,33.024-27.52,40.32 c-24-7.296-27.52-33.024-27.52-40.32v-30.272c0-1.472,1.088-2.624,2.496-2.624H280.896 M280.896,230.304h-49.92 c-2.432,0-4.288,1.984-4.288,4.48v30.272c0,1.728,0.192,11.008,4.928,20.928c4.992,10.624,13.184,17.92,23.872,21.12l0.512,0.192 l0.512-0.192c10.688-3.2,18.88-10.496,23.872-21.12c4.672-9.92,4.928-19.2,4.928-20.928v-30.272 C285.184,232.352,283.328,230.304,280.896,230.304L280.896,230.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M299.904,305.824c-7.808-2.624-16.128-1.408-24,3.776c-10.112,6.72-16.704,6.72-19.904,6.72 c-3.2,0-9.92,0-19.904-6.72c-7.872-5.184-16.192-6.528-24-3.776v7.808c4.928-2.304,11.776-3.328,19.904,2.112 c11.904,7.872,20.416,7.872,24,7.872c3.584,0,12.096,0,24-7.872c8.128-5.376,14.976-4.416,19.904-2.112V305.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M255.872,347.552c-51.52,0-93.376-41.92-93.376-93.376s41.92-93.376,93.376-93.376 s93.44,41.856,93.44,93.312S307.392,347.552,255.872,347.552z M255.872,164.448c-49.472,0-89.728,40.192-89.728,89.728 s40.192,89.728,89.728,89.728s89.728-40.256,89.728-89.792S305.408,164.448,255.872,164.448z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M153.792,261.92c0,0-0.384-11.392,10.624-11.392c0,0,0.192,4.48-3.712,6.528 C157.504,258.528,153.792,261.92,153.792,261.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M174.976,261.92c0,0,0.384-11.392-10.624-11.392c0,0-0.192,4.48,3.712,6.528 C171.392,258.528,174.976,261.92,174.976,261.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M358.016,250.464c0,0,0.384,11.392-10.624,11.392c0,0-0.192-4.48,3.712-6.528 C354.304,253.856,358.016,250.464,358.016,250.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M336.832,250.464c0,0-0.384,11.392,10.624,11.392c0,0,0.192-4.48-3.712-6.528 C340.416,253.856,336.832,250.464,336.832,250.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M261.632,358.304c0,0-11.392,0.384-11.392-10.624c0,0,4.48-0.192,6.528,3.712 C258.304,354.656,261.632,358.304,261.632,358.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M261.632,337.056c0,0-11.392-0.384-11.392,10.624c0,0,4.48,0.192,6.528-3.712 C258.304,340.704,261.632,337.056,261.632,337.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M250.176,154.144c0,0,11.392-0.384,11.392,10.624c0,0-4.48,0.192-6.528-3.712 C253.504,157.728,250.176,154.144,250.176,154.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M250.176,175.328c0,0,11.392,0.384,11.392-10.624c0,0-4.48-0.192-6.528,3.712 C253.504,171.616,250.176,175.328,250.176,175.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M187.776,332.448c0,0-8.384-7.808-0.576-15.616c0,0,3.328,3.008,1.92,7.232 C188.032,327.456,187.776,332.448,187.776,332.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M202.816,317.408c0,0-7.808-8.384-15.616-0.576c0,0,3.008,3.328,7.232,1.92 C197.824,317.664,202.816,317.408,202.816,317.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M324.096,179.936c0,0,8.384,7.808,0.576,15.616c0,0-3.328-3.008-1.92-7.232 C323.776,184.928,324.096,179.936,324.096,179.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M309.12,194.912c0,0,7.808,8.384,15.616,0.576c0,0-3.008-3.328-7.232-1.92 C313.984,194.72,309.12,194.912,309.12,194.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M332.096,324.32c0,0-7.808,8.384-15.616,0.576c0,0,3.008-3.328,7.232-1.92 C327.232,324.128,332.096,324.32,332.096,324.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M317.12,309.344c0,0-8.384,7.808-0.576,15.616c0,0,3.328-3.008,1.92-7.232 C317.376,314.336,317.12,309.344,317.12,309.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M179.712,188.064c0,0,7.808-8.384,15.616-0.576c0,0-3.008,3.328-7.232,1.92 C184.576,188.256,179.712,188.064,179.712,188.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M194.688,203.04c0,0,8.384-7.808,0.576-15.616c0,0-3.328,3.008-1.92,7.232 C194.496,198.112,194.688,203.04,194.688,203.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M163.776,300.512c0,0-4.672-10.432,5.376-14.592c0,0,1.92,4.096-1.024,7.424 C165.888,296.032,163.776,300.512,163.776,300.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M183.424,292.448c0,0-4.032-10.688-14.208-6.528c0,0,1.472,4.224,5.888,4.608 C178.688,290.72,183.424,292.448,183.424,292.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M348.032,211.808c0,0,4.672,10.432-5.376,14.592c0,0-1.92-4.096,1.024-7.424 C345.92,216.352,348.032,211.808,348.032,211.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M328.384,219.936c0,0,4.032,10.688,14.208,6.528c0,0-1.472-4.224-5.888-4.608 C333.12,221.664,328.384,219.936,328.384,219.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M300.288,348.32c0,0-10.368,4.672-14.592-5.376c0,0,4.096-1.92,7.424,1.024 C295.808,346.208,300.288,348.32,300.288,348.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M292.096,328.736c0,0-10.688,4.032-6.528,14.208c0,0,4.224-1.472,4.608-5.888 C290.432,333.408,292.096,328.736,292.096,328.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M211.584,164.064c0,0,10.432-4.672,14.592,5.376c0,0-4.096,1.92-7.424-1.024 C216.128,166.112,211.584,164.064,211.584,164.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M219.712,183.648c0,0,10.688-4.032,6.528-14.208c0,0-4.224,1.472-4.608,5.888 C221.376,179.04,219.712,183.648,219.712,183.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M222.08,352.736c0,0-10.688-4.032-6.528-14.208c0,0,4.224,1.472,4.608,5.888 C220.416,348.064,222.08,352.736,222.08,352.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M230.208,333.152c0,0-10.432-4.672-14.592,5.376c0,0,4.096,1.92,7.424-1.024 C225.728,335.264,230.208,333.152,230.208,333.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M289.728,159.712c0,0,10.688,4.032,6.528,14.208c0,0-4.224-1.472-4.608-5.888 C291.392,164.32,289.728,159.712,289.728,159.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M281.6,179.232c0,0,10.432,4.672,14.592-5.376c0,0-4.096-1.92-7.424,1.024 C286.08,177.248,281.6,179.232,281.6,179.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M352.384,289.952c0,0-4.032,10.688-14.208,6.528c0,0,1.472-4.224,5.888-4.608 C347.776,291.616,352.384,289.952,352.384,289.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M332.8,281.824c0,0-4.672,10.432,5.376,14.592c0,0,1.92-4.096-1.024-7.424 C334.912,286.304,332.8,281.824,332.8,281.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M159.424,222.432c0,0,4.032-10.688,14.208-6.528c0,0-1.472,4.224-5.888,4.608 C164.096,220.704,159.424,222.432,159.424,222.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M179.008,230.56c0,0,4.672-10.432-5.376-14.592c0,0-1.92,4.096,1.024,7.424 C176.896,226.016,179.008,230.56,179.008,230.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M156.928,281.76c0,0-2.624-11.072,8.192-13.312c0,0,1.088,4.416-2.432,7.104 C159.808,277.728,156.928,281.76,156.928,281.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M177.728,277.664c0,0-1.92-11.328-12.608-9.216c0,0,0.704,4.48,4.928,5.632 C173.504,275.04,177.728,277.664,177.728,277.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M354.88,230.624c0,0,2.624,11.072-8.192,13.312c0,0-1.088-4.416,2.368-7.104 C352,234.656,354.88,230.624,354.88,230.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M334.08,234.848c0,0,1.92,11.328,12.608,9.216c0,0-0.704-4.48-4.928-5.632 C338.432,237.408,334.08,234.848,334.08,234.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M281.408,355.232c0,0-11.072,2.624-13.312-8.192c0,0,4.416-1.088,7.104,2.432 C277.376,352.224,281.408,355.232,281.408,355.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M277.312,334.432c0,0-11.328,1.92-9.216,12.608c0,0,4.48-0.704,5.632-4.928 C274.688,338.656,277.312,334.432,277.312,334.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M230.4,157.216c0,0,11.072-2.624,13.312,8.192c0,0-4.416,1.088-7.104-2.432 C234.432,160.16,230.4,157.216,230.4,157.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M234.496,178.016c0,0,11.328-1.92,9.216-12.608c0,0-4.48,0.704-5.632,4.928 C237.12,173.728,234.496,178.016,234.496,178.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M203.904,344.224c0,0-9.728-6.016-3.584-15.232c0,0,3.904,2.304,3.328,6.72 C203.2,339.36,203.904,344.224,203.904,344.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M215.68,326.624c0,0-9.28-6.72-15.424,2.496c0,0,3.584,2.688,7.488,0.512 C210.88,327.84,215.68,326.624,215.68,326.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M307.904,168.16c0,0,9.728,6.016,3.584,15.232c0,0-3.904-2.304-3.328-6.72 C308.608,173.024,307.904,168.16,307.904,168.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M296.128,185.76c0,0,9.28,6.72,15.424-2.496c0,0-3.584-2.688-7.488-0.512 C300.928,184.608,296.128,185.76,296.128,185.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M344,308.128c0,0-6.016,9.728-15.232,3.584c0,0,2.304-3.904,6.72-3.328 C339.072,308.96,344,308.128,344,308.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M326.272,296.352c0,0-6.72,9.28,2.496,15.424c0,0,2.688-3.584,0.512-7.488 C327.488,301.216,326.272,296.352,326.272,296.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M167.808,204.256c0,0,6.016-9.728,15.232-3.584c0,0-2.304,3.904-6.72,3.328 C172.672,203.424,167.808,204.256,167.808,204.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M185.472,216.032c0,0,6.72-9.28-2.496-15.424c0,0-2.688,3.584-0.512,7.488 C184.32,211.232,185.472,216.032,185.472,216.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M174.208,317.664c0,0-6.72-9.28,2.496-15.424c0,0,2.688,3.584,0.512,7.488 C175.424,312.8,174.208,317.664,174.208,317.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M191.808,305.952c0,0-6.016-9.728-15.232-3.584c0,0,2.304,3.904,6.72,3.328 C186.88,305.12,191.808,305.952,191.808,305.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M337.6,194.72c0,0,6.72,9.28-2.496,15.424c0,0-2.688-3.584-0.512-7.488 C336.384,199.52,337.6,194.72,337.6,194.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M320,206.56c0,0,6.016,9.728,15.232,3.584c0,0-2.304-3.904-6.72-3.328 C324.928,207.264,320,206.56,320,206.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M317.376,337.952c0,0-9.28,6.72-15.424-2.496c0,0,3.584-2.688,7.488-0.512 C312.576,336.736,317.376,337.952,317.376,337.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M305.6,320.224c0,0-9.728,6.016-3.584,15.232c0,0,3.904-2.304,3.328-6.72 C304.768,325.152,305.6,320.224,305.6,320.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M194.432,174.56c0,0,9.28-6.72,15.424,2.496c0,0-3.584,2.688-7.488,0.512 C199.296,175.648,194.432,174.56,194.432,174.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M206.208,192.16c0,0,9.728-6.016,3.584-15.232c0,0-3.904,2.304-3.328,6.72 C206.976,187.232,206.208,192.16,206.208,192.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M241.6,357.408c0,0-11.328-1.92-9.216-12.608c0,0,4.48,0.704,5.632,4.928 C238.976,353.248,241.6,357.408,241.6,357.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M245.696,336.608c0,0-11.072-2.624-13.312,8.192c0,0,4.416,1.088,7.104-2.368 C241.728,339.552,245.696,336.608,245.696,336.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M270.208,154.912c0,0,11.328,1.92,9.216,12.608c0,0-4.48-0.704-5.632-4.928 C272.768,159.264,270.208,154.912,270.208,154.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M266.112,175.712c0,0,11.072,2.624,13.312-8.192c0,0-4.416-1.088-7.104,2.432 C270.08,172.832,266.112,175.712,266.112,175.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M357.184,270.56c0,0-1.92,11.328-12.608,9.216c0,0,0.704-4.48,4.928-5.632 C352.896,273.056,357.184,270.56,357.184,270.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M336.384,266.336c0,0-2.624,11.072,8.192,13.312c0,0,1.088-4.416-2.432-7.104 C339.328,270.304,336.384,266.336,336.384,266.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M154.688,241.952c0,0,1.92-11.328,12.608-9.216c0,0-0.704,4.48-4.928,5.632 C158.912,239.328,154.688,241.952,154.688,241.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M175.488,246.048c0,0,2.624-11.072-8.192-13.312c0,0-1.088,4.416,2.432,7.104 C172.48,242.016,175.488,246.048,175.488,246.048z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBz);
export default __webpack_public_path__ + "static/media/bz.e51d9d9213e41af2326cb460441760e0.svg";
export { ForwardRef as ReactComponent };